import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withRouterConfig } from "@angular/router";
import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor } from "@core/jwt.interceptor";
import { errorInterceptor } from "@core/error.interceptor";
import { appInitializer } from "@core/app.initializer";
import { AuthenticationService } from "@services/authentication.service";
import { msgInterceptor } from "@core/api-messages.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      return (appInitializer)(inject(AuthenticationService))();
    }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, msgInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' }))
  ]
};